import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { IMG, BTN, BRAND } from "@/lib/design";

export default function ClosingCTASection() {
    return (
        <section
            className="relative py-20 md:py-24 grain"
            style={{
                backgroundImage: `linear-gradient(rgba(14,42,71,0.94), rgba(8,24,43,0.94)), url(${IMG.forestPath})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className="relative max-w-3xl mx-auto px-6 text-center text-white">
                <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                    Take the next step
                </p>
                <h2 className="mt-3 font-[Outfit] text-3xl md:text-5xl font-semibold tracking-tight">
                    A young man&apos;s future can start with one phone call.
                </h2>
                <p className="mt-5 text-[16px] md:text-[17px] text-white/80 leading-relaxed">
                    If you&apos;re a parent, guardian, caseworker, or partner
                    seeking placement, our team is ready to listen —
                    confidentially, and without obligation.
                </p>
                <div className="mt-9 flex flex-wrap justify-center gap-3">
                    <Link to="/referrals" className={BTN.secondary} data-testid="closing-referral-cta">
                        Make a Referral <ArrowRight className="h-4 w-4" />
                    </Link>
                    <a
                        href={BRAND.phoneHref}
                        className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 text-white px-7 py-3.5 text-[14.5px] font-medium hover:bg-white hover:text-[#0E2A47] transition-colors"
                        data-testid="closing-call-cta"
                    >
                        <Phone className="h-4 w-4" />
                        Call {BRAND.phone}
                    </a>
                </div>
            </div>
        </section>
    );
}
